import { render, staticRenderFns } from "./vipManage.vue?vue&type=template&id=ec5b4db0&"
import script from "./vipManage.vue?vue&type=script&lang=js&"
export * from "./vipManage.vue?vue&type=script&lang=js&"
import style0 from "./vipManage.vue?vue&type=style&index=0&id=ec5b4db0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports